export default __webpack_public_path__ + "static/media/Tailwindcss1.16ab8cee.webp";